import { checkStateHasReportData, useCMAStore } from 'features/CMA/infra/react/CMAState'
import { PartialRange } from 'features/valueObjects/Range'
import { HouseSizeFilterCardDumb } from 'presentation/screens/CompsScreen/components/CompsFilterPanel/components/HouseSizeFilterCard/HouseSizeFilterCard.dumb'
import { HouseSizeFilterCardDumbProps as Props } from 'presentation/screens/CompsScreen/components/CompsFilterPanel/components/HouseSizeFilterCard/HouseSizeFilterCard.dumb.props'
import { shallow } from 'zustand/shallow'

export const HouseSizeFilterCard = () => {
  const isReady = useCMAStore(state =>
    checkStateHasReportData(state.local.report),
  )

  const {
    subjectValue,
    filterValue,
  } = useCMAStore(state => {
    if (!checkStateHasReportData(state.local.report)) {
      return {
        subjectValue: null,
        filterValue: null,
      }
    }

    return {
      subjectValue: state.local.report.data.salesListInfo.subject?.livingAreaSqft ?? null,
      filterValue: state.local.report.data.filters.livingAreaSqft?.range ?? PartialRange.EMPTY,
    }
  }, shallow)
  const filterComps = useCMAStore(state => state.actions.filterComps.execute)

  const handleOnValueChange: Props['onChange'] = range => {
    void filterComps({
      livingAreaSqft: {
        range,
      },
    })
  }

  if (!isReady) return null

  return (
    <HouseSizeFilterCardDumb
      value={filterValue}
      onChange={handleOnValueChange}
      subjectValue={subjectValue}
    />
  )
}
